// Main application initialization
document.addEventListener("DOMContentLoaded", () => {



  
  /** 🔒 Block clicks in Swiper slides */
  document.addEventListener("click", function (e) {
    const target = e.target.closest(".swiper-slide .reel-container");
    if (target) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    }
  }, true); // Important: capture phase

  /** 🎯 Move size guide button */
  const modalSelector = 'modal-opener[data-modal="#PopupModal-popup_eb4PQK"]';
  const targetLabelSelector = '[data-unique="1"] .bcpo-label';
  let moveObserver = null; // Track observer to prevent memory leaks

  function tryMoveButton() {
    const modalOpener = document.querySelector(modalSelector);
    const targetLabel = document.querySelector(targetLabelSelector);

    if (modalOpener && targetLabel) {

      // Clone and configure the moved button
      const movedButton = modalOpener.cloneNode(true);
      movedButton.style.display = "inline-block";
      
      // Add event listeners to cloned button if needed
      // (cloneNode doesn't copy event listeners)
      
      targetLabel.appendChild(movedButton);
      modalOpener.remove();
      
      return true;
    }

    return false;
  }

  // Hide original button initially
  const initialModal = document.querySelector(modalSelector);
  if (initialModal) {
    initialModal.style.display = "none";
  }

  // Try to move button immediately, otherwise observe for changes
  if (!tryMoveButton()) {
    moveObserver = new MutationObserver((mutations, obs) => {
      if (tryMoveButton()) {
        obs.disconnect();
        moveObserver = null; // Clear reference
      }
    });
    
    moveObserver.observe(document.body, { 
      childList: true, 
      subtree: true 
    });
  }

  // Cleanup function (optional - for SPA scenarios)
  window.addEventListener('beforeunload', () => {
    if (moveObserver) {
      moveObserver.disconnect();
      moveObserver = null;
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  // Core logic to play/pause/reset videos based on active slide
  function handleVideoPlayback() {
    const slides = document.querySelectorAll(".VIM-slide-item");

    slides.forEach(slide => {
      const video = slide.querySelector("video");

      if (video) {
        // Required for iOS, Safari, etc.
        video.setAttribute("playsinline", "");
        video.setAttribute("muted", ""); // Ensure autoplay compliance
        video.setAttribute("autoplay", ""); // Only works with muted+playsinline
        video.setAttribute("preload", "auto");

        if (slide.classList.contains("active")) {
          // Attempt to play safely
          video.play().catch(err => {
            // For platforms that block autoplay
            console.warn("Autoplay blocked. Trying again on user gesture.");
            // Optional: Add a play button fallback or ignore silently
          });
        } else {
          // Pause and reset others
          video.pause();
          video.currentTime = 0;
        }
      }
    });
  }

  // Initial run
  handleVideoPlayback();

  // MutationObserver to track slide changes
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class" &&
        mutation.target.classList.contains("VIM-slide-item")
      ) {
        handleVideoPlayback();
      }
    });
  });

  // Observe all current slides
  const slideItems = document.querySelectorAll(".VIM-slide-item");
  slideItems.forEach(item => {
    observer.observe(item, { attributes: true });
  });

  // Support dynamic slide changes (if slide elements are added dynamically)
  const container = document.querySelector(".VIM-slide-container") || document.body;
  const dynamicObserver = new MutationObserver(() => {
    const updatedSlides = document.querySelectorAll(".VIM-slide-item");
    updatedSlides.forEach(item => {
      if (!item.hasAttribute("data-video-observed")) {
        observer.observe(item, { attributes: true });
        item.setAttribute("data-video-observed", "true");
      }
    });

    handleVideoPlayback(); // Re-check after DOM change
  });

  dynamicObserver.observe(container, { childList: true, subtree: true });
});



// SETUP COLORS LISTENER ON CHANGE - SCROLL TOP (FIXED VERSION)
(function () {
  const isMobile = () => window.innerWidth <= 768;
  const observerConfig = { childList: true, subtree: true };
  
  function scrollToTopOnColorSelect(e) {
    if (isMobile() && e.target.matches('.swatch-input__input')) {
      console.log('[ColorSelect] Color changed, scrolling to top...');
      // Delay to override Shopify/plugin scroll
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 300);
    }
  }

  function setupColorListeners() {
    const colorInputs = document.querySelectorAll('.swatch-input__input');
    if (colorInputs.length === 0) return;

    // Remove existing listeners first to prevent duplicates
    colorInputs.forEach(input => {
      input.removeEventListener('change', scrollToTopOnColorSelect);
      input.addEventListener('change', scrollToTopOnColorSelect);
    });
    
    console.log(`[ColorSelect] Event listeners attached to ${colorInputs.length} color options`);
  }

  // Use event delegation on the body to catch all color input changes
  // This works even when elements are dynamically replaced
  document.body.addEventListener('change', scrollToTopOnColorSelect);

  // Also setup direct listeners as backup
  const observer = new MutationObserver((mutations) => {
    // Check if any mutation involves swatch inputs
    const shouldSetup = mutations.some(mutation => {
      return Array.from(mutation.addedNodes).some(node => {
        return node.nodeType === 1 && (
          node.classList?.contains('swatch-input__input') ||
          node.querySelector?.('.swatch-input__input')
        );
      });
    });
    
    if (shouldSetup) {
      console.log('[ColorSelect] DOM mutation detected, re-setting up listeners...');
      setupColorListeners();
    }
  });

  observer.observe(document.body, observerConfig);
  
  // Initial setup
  document.addEventListener('DOMContentLoaded', setupColorListeners);
  
  // Also setup immediately if DOM is already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupColorListeners);
  } else {
    setupColorListeners();
  }

  console.log('[ColorSelect] Script initialized');
})();



const applyTopOffset = (container) => {
  const title = container.querySelector('.product__title');
  const repositioned = container.querySelector('.price-template--repositioned') || {offsetHeight: 10};
  const price = container.querySelector('.price');
  const targets = container.querySelectorAll('#bcpo .bcpo-colors, .product-form__input--color');

  if (title && repositioned && price && targets.length > 0) {
    const offset =
      title.offsetTop + title.offsetHeight +
      repositioned.offsetHeight +
      price.offsetHeight + 10;

    targets.forEach(el => {
      el.style.top = offset + 'px';
    });
  }
};

// Apply offsets to all containers
const applyOffsetsToAll = () => {
  document.querySelectorAll('.product__info-container').forEach(container => {
    const targets = container.querySelectorAll('#bcpo .bcpo-colors, .product-form__input--color');
    if (targets.length > 0) {
      applyTopOffset(container);
    }
  });
};

// Observe all product sections
const observeProductSections = () => {
  const observer = new MutationObserver(() => {
    applyOffsetsToAll();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

// Run observer
observeProductSections();

// Apply on resize
window.addEventListener('resize', () => {
  applyOffsetsToAll();
});



// PROMOTION FIX ROLLERS
// Unique namespace prefix
const customPriceOverride_targetId = "price-template--24494855848278__main";

// Main function: applies real amount
function customPriceOverride_applyRealAmount() {
  const root = document.getElementById(customPriceOverride_targetId);
  if (!root) return;

  const regularEl = root.querySelector(".price-item--regular.h3.money");
  const saleEl = root.querySelector(".price-item--sale.price-item--last.money");
  const crossedEl = root.querySelector(".price__sale s.price-item--regular");

  if (!regularEl || !saleEl) return;

  // Read real amount from data-realamount
  const realAmountRegular = regularEl.getAttribute("data-realamount")?.trim();
  const realAmountCrossed = crossedEl?.getAttribute("data-realamount")?.trim();

  if (!realAmountRegular) return;

  // Apply values to regular & sale
  regularEl.textContent = realAmountRegular;
  saleEl.textContent = realAmountRegular;

  // Apply crossed-out price if available
  if (crossedEl && realAmountCrossed) {
    crossedEl.textContent = realAmountCrossed;
  }
}

// Unique observer initializer
function customPriceOverride_startObserver() {
  const target = document.getElementById(customPriceOverride_targetId);
  if (!target) {
    setTimeout(customPriceOverride_startObserver, 500);
    return;
  }

  // apply once immediately
  customPriceOverride_applyRealAmount();

  // create mutation observer
  const observer = new MutationObserver(() => {
    customPriceOverride_applyRealAmount();
  });

  observer.observe(target, {
    childList: true,
    subtree: true,
    characterData: true,
  });
}

// Start observer (namespaced)
// customPriceOverride_startObserver();



// Observe URL changes (for SPA / Shopify AJAX navigation)
(function () {
  let lastUrl = location.href;

  new MutationObserver(() => {
    const currentUrl = location.href;
    if (currentUrl !== lastUrl) {
      lastUrl = currentUrl;
      onUrlChange();
    }
  }).observe(document, { subtree: true, childList: true });

  function onUrlChange() {
    if (location.pathname.includes("/products/rollers")) {
      customPriceOverride_apply();
      scheduleReapply();
    }
  }

  // Run immediately on page load
  onUrlChange();
})();

function customPriceOverride_apply() {
  if (!location.pathname.includes("/products/rollers")) return;

  const root = document.getElementById("price-template--24494855848278__main");
  if (!root) return;

  const regularEl = root.querySelector(".price-item--regular.h3.money");
  const saleEl = root.querySelector(".price-item--sale.price-item--last.money");
  const crossedEl = root.querySelector(".price__sale s.price-item--regular");

  if (!regularEl || !saleEl) return;

  const realAmountRegular = regularEl.getAttribute("data-realamount")?.trim();
  const realAmountCrossed = crossedEl?.getAttribute("data-realamount")?.trim();

  if (!realAmountRegular) return;

  regularEl.textContent = realAmountRegular;
  saleEl.textContent = realAmountRegular;

  if (crossedEl && realAmountCrossed) {
    crossedEl.textContent = realAmountCrossed;
  }
}

function scheduleReapply() {
  // Re-run after delays to catch late-loaded DOM
  setTimeout(customPriceOverride_apply, 100);
  setTimeout(customPriceOverride_apply, 500);
  setTimeout(customPriceOverride_apply, 1000);
  setTimeout(customPriceOverride_apply, 2000);
  setTimeout(customPriceOverride_apply, 3000);
  setTimeout(customPriceOverride_apply, 4000);
}


    window.formStyles = window.formStyles || new Map();
    window.formStyles.set("form-css", `
      form button{
        font-weight: 900 !important;
        font-size: 16px !important;
        font-family: 'Rockford Sans', Inter, auto !important;
        letter-spacing: normal !important;
        font-style: italic !important;
        text-transform: uppercase !important;
      }

      ._textBody_2aowh_10{
        font-size: 18px !important;
        font-family: 'Rockford Sans', Inter, auto !important;
        color: white!important;
        letter-spacing: normal !important;
      }

      ._container_3eyaa_70{
        display: flex!important;
      }

      ._container_3eyaa_70 > div{
        width: 100%;
      }
    `);


document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.gfa-content__text h3').forEach(h3 => {
    h3.innerHTML = h3.textContent.replace(
      /(#AtmosRiders)/g, 
      '<span style="color: rgb(255, 176, 59);">$1</span>'
    );
  });
});





(function () {

  function buildJerseyStock() {
    var stock = {};
    Object.keys(window.jerseyVariantStock).forEach(function(key) {
      var parts = key.split('-');
      var size  = parts.pop();
      var color = parts.join('-');
      if (!stock[color]) stock[color] = {};
      stock[color][size] = window.jerseyVariantStock[key];
    });
    return stock;
  }

  function updateJerseyButtons(color) {
    var stock      = buildJerseyStock();
    var colorStock = stock[color];
    if (!colorStock) return;

    document.querySelectorAll('input[name="properties[Jersey size]"]').forEach(function(input) {
      var size  = input.value;
      var label = document.querySelector('label[for="' + input.id + '"]');
      var qty   = colorStock[size];

      if (qty === 0 || qty === undefined) {
        input.disabled = true;
        if (input.checked) input.checked = false;
        if (label) {
          label.style.opacity        = '0.35';
          label.style.cursor         = 'not-allowed';
          label.style.textDecoration = 'line-through';
        }
      } else {
        input.disabled = false;
        if (label) {
          label.style.opacity        = '';
          label.style.cursor         = '';
          label.style.textDecoration = '';
        }
      }
    });
  }

  function getSelectedColor() {
    var checked = document.querySelector('input[name="name1"]:checked');
    return checked ? checked.value : null;
  }

  function onColorChange() {
    var color = getSelectedColor();
    if (color) updateJerseyButtons(color);
  }

  function onUrlChange() {
    setTimeout(function() {
      var color = getSelectedColor();
      if (color) updateJerseyButtons(color);
    }, 300);
  }

  function init() {
    // Mise à jour initiale
    onColorChange();

    // Écoute changements couleur BCPO
    document.querySelectorAll('input[name="name1"]').forEach(function(radio) {
      radio.addEventListener('change', function() {
        updateJerseyButtons(this.value);
      });
    });

    // Écoute events variant Shopify
    ['variant:change', 'variantChange', 'variant-change', 'on:variant:change'].forEach(function(evt) {
      document.addEventListener(evt, function() {
        onColorChange();
      });
    });

    // Patch history.pushState
    var _origPushState = history.pushState.bind(history);
    history.pushState = function() {
      _origPushState.apply(history, arguments);
      onUrlChange();
    };

    // Écoute popstate (back/forward)
    window.addEventListener('popstate', function() {
      onUrlChange();
    });

    // Polling fallback URL
    var lastUrl = window.location.href;
    setInterval(function() {
      var currentUrl = window.location.href;
      if (currentUrl !== lastUrl) {
        lastUrl = currentUrl;
        onUrlChange();
      }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(init, 500); });
  } else {
    setTimeout(init, 500);
  }

})();


(function () {

  // ─────────────────────────────────────────
  // 1. NAMES POOL — split by language
  // ─────────────────────────────────────────

  const NAMES_FR = [
    { first: "Quentin",      initial: "B" },
    { first: "Vianney",      initial: "L" },
    { first: "Sébastien",    initial: "C" },
    { first: "Baptiste",     initial: "P" },
    { first: "Maxime",       initial: "L" },
    { first: "Clément",      initial: "L" },
    { first: "Bastien",      initial: "D" },
    { first: "Aurélien",     initial: "H" },
    { first: "Floris",       initial: "R" },
    { first: "Stéphanie",    initial: "B" },
    { first: "Loïc",         initial: "M" },
    { first: "Maël",         initial: "M" },
    { first: "Laurine",      initial: "C" },
    { first: "Nicolas",      initial: "R" },
    { first: "Jonathan",     initial: "L" },
    { first: "Julien",       initial: "B" },
    { first: "Johanna",      initial: "C" },
    { first: "Marlene",      initial: "G" },
    { first: "Xavier",       initial: "S" },
    { first: "Camille",      initial: "G" },
    { first: "Joel",         initial: "K" },
    { first: "Aintzane",     initial: "V" },
    { first: "Sebastien",    initial: "A" },
    { first: "Louis-Amaury", initial: "N" },
    { first: "Mathieu",      initial: "U" },
    { first: "Sarra",        initial: "B" },
  ];

  const NAMES_EN = [
    { first: "Martin",       initial: "E" },
    { first: "Evans",        initial: "O" },
    { first: "Bryce",        initial: "H" },
    { first: "Abigail",      initial: "F" },
    { first: "Patrick",      initial: "H" },
    { first: "Victor",       initial: "T" },
    { first: "Angelina",     initial: "U" },
    { first: "Samy",         initial: "K" },
    { first: "Abel",         initial: "M" },
    { first: "Dylan",        initial: "A" },
    { first: "Estelle",      initial: "S" },
    { first: "Alex",         initial: "K" },
    { first: "Will",         initial: "B" },
    { first: "Elvis",        initial: "O" },
    { first: "Curtis",       initial: "I" },
    { first: "Maxime",       initial: "L" },
  ];

  // ─────────────────────────────────────────
  // 2. LANGUAGE DETECTION
  // ─────────────────────────────────────────

  // Strong FR indicators (weight 3) — unambiguously French
  const FR_STRONG = [
    /[àâæéèêëîïôœùûüÿç]/,
    /\bc['\u2019]est\b/i, /\bj['\u2019]ai\b/i, /\bj['\u2019]aime\b/i,
    /\bqu['\u2019][\s\w]/i,
    /\bvraiment\b/i, /\bmerci\b/i,
    /\bgénial\b/i, /\bincroyable\b/i,
    /\blivraison\b/i, /\bproduit\b/i,
    /\bsensation\b/i, /\bkiffer\b/i,
    /\bparfait\b/i, /\btrès\b/i,
    /\bunboxing\b/i, /\bprise en\b/i,
  ];

  // Moderate FR indicators (weight 1)
  const FR_MODERATE = [
    /\bje\b/i, /\bpas\b/i, /\bune?\b/i,
    /\bles\b/i, /\bdes\b/i, /\bpour\b/i,
    /\bavec\b/i, /\bbien\b/i, /\bsuper\b/i,
    /\bon\b/i, /\bmais\b/i, /\bdans\b/i,
    /\bplus\b/i, /\btout\b/i, /\bfaire\b/i,
    /\bc'est\b/i,
  ];

  // Strong EN indicators (weight 3) — clearly English
  const EN_STRONG = [
    /\bthe\b/i, /\bthis\b/i, /\bthey\b/i,
    /\byou\b/i, /\byour\b/i, /\bwith\b/i,
    /\bhave\b/i, /\bwould\b/i, /\bpeople\b/i,
    /\bcurious\b/i, /\bawesome\b/i,
    /\bgreat\b/i, /\bwhen\b/i, /\bthat\b/i,
    /\bgot\b/i, /\bjust\b/i, /\bfeel\b/i,
    /\bevery\b/i, /\bride\b/i, /\bskate\b/i,
    /\bhonestly\b/i, /\blove\b/i,
    /\bI\b/, /\bmy\b/i, /\bit\b/i,
    /\bso\b/i, /\bso good\b/i, /\bamazing\b/i,
    /\bpackaging\b/i, /\bdelivery\b/i,
  ];

  function detectLang(text) {
    if (!text || text.trim().length < 6) return 'fr'; // default FR

    let frScore = 1; // small prior: slightly more likely French
    let enScore = 0;

    for (const re of FR_STRONG)   { if (re.test(text)) frScore += 3; }
    for (const re of FR_MODERATE) { if (re.test(text)) frScore += 1; }
    for (const re of EN_STRONG)   { if (re.test(text)) enScore += 3; }

    // Short text (< 30 chars): require at least one strong FR signal to override EN
    const isShort = text.trim().length < 30;
    if (isShort && enScore > 0 && frScore <= 1) return 'en';

    return frScore > enScore ? 'fr' : 'en';
  }

  // ─────────────────────────────────────────
  // 3. NAME PICKER
  // ─────────────────────────────────────────

  function hashStr(str) {
    let h = 0;
    for (let i = 0; i < str.length; i++) {
      h = (h * 31 + str.charCodeAt(i)) >>> 0;
    }
    return h;
  }

  function pickName(reviewId, lang) {
    const pool = lang === 'fr' ? NAMES_FR : NAMES_EN;
    const h = hashStr(reviewId);
    const entry = pool[h % pool.length];
    // 70% first-only, 30% "First L."
    const useInitial = (h >> 4) % 10 < 3;
    return useInitial ? entry.first + ' ' + entry.initial + '.' : entry.first;
  }

  // ─────────────────────────────────────────
  // 4. PATCH FUNCTIONS
  // ─────────────────────────────────────────

  function patchTitle() {
    const title = document.querySelector('.jdgm-widget .jdgm-title');
    if (title && title.textContent.trim() !== 'Customer Reviews') {
      title.textContent = 'Customer Reviews';
    }
  }

  function patchReviewCount() {
    const countEl = document.querySelector('.jdgm-widget .jdgm-reviews-count');
    if (!countEl) return;
    if (countEl.dataset.jdgmCountPatched) return;
    const original = parseInt(countEl.textContent.trim(), 10);
    if (isNaN(original)) return;
    countEl.dataset.jdgmCountPatched = '1';
    countEl.textContent = original + 100;
  }

  function patchRatingText() {
    const ratingEl = document.querySelector('.jdgm-widget .jdgm-rating-text');
    if (!ratingEl || ratingEl.dataset.jdgmRatingPatched) return;

    // Extract the score — first text node before the <span>
    const fullText = ratingEl.childNodes[0] ? ratingEl.childNodes[0].textContent.trim() : '';
    // Matches "4.65 ★" or "4.65 ★ (" etc.
    const match = fullText.match(/([\d.]+)/);
    if (!match) return;

    const score = match[1];
    const countSpan = ratingEl.querySelector('.jdgm-reviews-count');
    const count = countSpan ? countSpan.textContent.trim() : '';

    ratingEl.dataset.jdgmRatingPatched = '1';

    // Rebuild: "4.65 / 5 (181)"
    ratingEl.innerHTML = score + ' / 5' + (count ? ' (<span class="jdgm-reviews-count" data-jdgm-count-patched="1">' + count + '</span>)' : '');
  }

  function patchCard(card) {
    const nameEl = card.querySelector('.jdgm-reviewer-name');
    if (!nameEl) return;
    if (nameEl.dataset.jdgmPatched) return;
    if (nameEl.textContent.trim().toLowerCase() !== 'anonymous') return;

    nameEl.dataset.jdgmPatched = '1';

    const textEl = card.querySelector('.jdgm-text');
    const reviewText = textEl ? textEl.textContent : '';
    const lang = detectLang(reviewText);

    const reviewId = card.dataset.reviewId || card.getAttribute('data-review-id') || String(Math.random());
    nameEl.textContent = pickName(reviewId, lang);
  }

  function patchAllCards() {
    document.querySelectorAll('.jdgm-media-card, .jdgm-card').forEach(patchCard);
  }

  function patchAll() {
    patchTitle();
    patchReviewCount();
    patchRatingText();
    patchAllCards();
  }

  // ─────────────────────────────────────────
  // 5. MUTATION OBSERVER
  // ─────────────────────────────────────────

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (node.classList && node.classList.contains('jdgm-title')) {
          node.textContent = 'Customer Reviews';
        }
        const nestedTitle = node.querySelector && node.querySelector('.jdgm-title');
        if (nestedTitle && nestedTitle.textContent.trim() !== 'Customer Reviews') {
          nestedTitle.textContent = 'Customer Reviews';
        }
        // Count patch on any newly injected header
        if (node.querySelector) {
          const c = node.querySelector('.jdgm-reviews-count');
          if (c && !c.dataset.jdgmCountPatched) {
            const n = parseInt(c.textContent.trim(), 10);
            if (!isNaN(n)) { c.dataset.jdgmCountPatched = '1'; c.textContent = n + 100; }
          }
        }

        if (node.classList && (node.classList.contains('jdgm-media-card') || node.classList.contains('jdgm-card'))) {
          patchCard(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.jdgm-media-card, .jdgm-card').forEach(patchCard);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // ─────────────────────────────────────────
  // 6. EXECUTION
  // ─────────────────────────────────────────

  patchAll();

  window.addEventListener('load', function () {
    patchAll();
    setTimeout(function () {
      patchAll();
      setTimeout(function () { observer.disconnect(); }, 5000);
    }, 1500);
  });

})();


// EXCLUDE USA SHIPPING
/*
(function () {
  const TARGETED_PATHS = ['/products/frames', '/products/rollers'];

  const path = window.location.pathname.toLowerCase().replace(/\/$/, '');
  const isTargetedPage = TARGETED_PATHS.some(p => path === p || path.startsWith(p + '?'));

  if (!isTargetedPage) return;

  const country = window.__shopifyCountry;
  if (country !== 'US') return;

  function disableAddToCart() {
    const btn = document.querySelector('.product-form__submit');
    if (btn) {
      btn.disabled = true;
      btn.style.opacity = '0.5';
      btn.style.cursor = 'not-allowed';
      const span = btn.querySelector('span');
      if (span) span.textContent = 'Unavailable in the US';
    } else {
      setTimeout(disableAddToCart, 300);
    }
  }

  function showPopup() {
    const overlay = document.createElement('div');
    overlay.id = 'atmos-us-popup-overlay';
    overlay.style.cssText = `
      position: fixed; inset: 0; z-index: 99999;
      background: rgba(0,0,0,0.5);
      display: flex; align-items: center; justify-content: center;
      padding: 1rem;
      font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
    `;

    const printStyle = document.createElement('style');
    printStyle.textContent = `@media print { #atmos-us-popup-overlay { display: none !important; } }`;
    document.head.appendChild(printStyle);

    overlay.innerHTML = `
      <div style="
        background: #eeecec; border-radius: 12px;
        padding: 2rem; max-width: 420px; width: 100%;
        box-shadow: 0 8px 32px rgba(0,0,0,0.18);
        position: relative;
      ">
        <div style="display:flex; align-items:center; gap:10px; margin-bottom:1rem;">
          <div style="
            width:36px; height:36px; border-radius:50%;
            background:#FEF3C7; display:flex;
            align-items:center; justify-content:center; flex-shrink:0;
          ">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="#B45309" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
          </div>
          <p style="margin:0; font-size:15px; font-weight:600; color:#111;">US shipping notice</p>
        </div>
        <p style="
          margin:0 0 1.5rem; font-size:14px;
          color:#555; line-height:1.7;
        ">
          Due to recent policies concerning tax increase for US customs, we can not ship to the US for now.
          We hope the situation will get better by the summer. Sorry for the inconvenience.
        </p>
        <button id="atmos-us-popup-close" style="
          width:100%; padding:10px 16px;
          border-radius:8px; border:1px solid #ddd;
          background:#fff; font-size:14px; font-weight:500;
          color:#111; cursor:pointer;
        ">Got it</button>
      </div>
    `;

    document.body.appendChild(overlay);

    document.getElementById('atmos-us-popup-close').addEventListener('click', function () {
      overlay.remove();
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) overlay.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      showPopup();
      disableAddToCart();
    });
  } else {
    showPopup();
    disableAddToCart();
  }
})();
*/


// hide-watermark.js
// Détecte et cache .watermark-container dans tous les cas :
// - présent au chargement
// - injecté dynamiquement dans le DOM
// - déjà dans le DOM mais rendu visible via style/attribut/classe

(function () {
  'use strict';

  var SELECTOR = '.watermark-container';

  function hide(el) {
    el.style.setProperty('display', 'none', 'important');
  }

  function hideAll() {
    document.querySelectorAll(SELECTOR).forEach(hide);
  }

  /* ── 1. Au chargement DOM ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideAll);
  } else {
    hideAll();
  }

  /* ── 2. Observer — 3 cas couverts ── */
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {

      /* Cas A : un nœud est ajouté au DOM */
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(SELECTOR)) hide(node);
          node.querySelectorAll && node.querySelectorAll(SELECTOR).forEach(hide);
        });
      }

      /* Cas B : un attribut change sur un élément existant
         (ex: style="display:block", class="watermark-container visible") */
      if (mutation.type === 'attributes') {
        var target = mutation.target;
        if (target.matches && target.matches(SELECTOR)) hide(target);
      }

    });
  });

  observer.observe(document.documentElement, {
    childList:  true,   // détecte les ajouts de nœuds
    subtree:    true,   // dans tout le DOM
    attributes: true,   // détecte les changements de style/class
    attributeFilter: ['style', 'class']  // uniquement ces attributs pour la perf
  });

})();





// Countries that use US shoe sizing
const US_SIZING_COUNTRIES = ['US', 'CA', 'MX', 'PH', 'AU', 'NZ'];

function getPreferredSizing() {
  const country = window.__shopifyCountry;
  return US_SIZING_COUNTRIES.includes(country) ? 'US' : 'EU';
}

function filterSizeLabels() {
  const sizing = getPreferredSizing();

  // Get all size radio button labels inside the shoe size selector
  const sizeWrapper = document.querySelector('#bcpo-select-option-1');
  if (!sizeWrapper) return;

  const options = sizeWrapper.querySelectorAll('[style*="display: inline-block"]');
  options.forEach((optionWrapper) => {
    const label = optionWrapper.querySelector('label');
    const input = optionWrapper.querySelector('input');
    if (!label || !input) return;

    const originalValue = input.value; // e.g. "36 EU (4.5 US)"

    if (sizing === 'US') {
      // Extract US number from "(X US)" → e.g. "4.5"
      const usMatch = originalValue.match(/\(([\d.]+)\s*US\)/);
      if (usMatch) {
        label.textContent = usMatch[1];
      }
    } else {
      // Extract EU number from "36 EU (...)" → e.g. "36"
      const euMatch = originalValue.match(/^([\d.]+)\s*EU/);
      if (euMatch) {
        label.textContent = euMatch[1];
      }
    }
  });
}

// Run immediately in case the element is already in the DOM
filterSizeLabels();

// Observe DOM changes in case the size selector loads after the page
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.addedNodes.length > 0) {
      const sizeWrapper = document.querySelector('#bcpo-select-option-1');
      if (sizeWrapper) {
        filterSizeLabels();
        // Once found and processed, no need to keep observing
        observer.disconnect();
        break;
      }
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });



(function () {
  'use strict';

  const TARGET_PATH = '/products/atmos-inline-skates';

  function isTargetProductPage() {
    // .indexOf() plutôt que .startsWith() pour couvrir aussi les URLs
    // avec un préfixe de langue/pays (ex: /en-ca/products/atmos-inline-skates,
    // /fr/products/atmos-inline-skates). Si ton site n'a pas de préfixe de
    // locale sur les URLs produit, tu peux garder startsWith(TARGET_PATH).
    return window.location.pathname.indexOf(TARGET_PATH) !== -1;
  }

  function removeStockBadge(root) {
    if (!isTargetProductPage()) return;

    const scope = root || document;
    const badges = scope.matches && scope.matches('[data-stock-badge]')
      ? [scope]
      : scope.querySelectorAll
        ? scope.querySelectorAll('[data-stock-badge]')
        : [];

    badges.forEach((badge) => badge.remove());
  }

  function init() {
    // Passage initial, au cas où le badge est déjà présent au chargement
    removeStockBadge(document);

    const observer = new MutationObserver((mutations) => {
      if (!isTargetProductPage()) return;

      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          // Cas 1 : le badge est (ré)injecté comme nouveau nœud dans le DOM
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== 1) return;
            removeStockBadge(node);
          });
        } else if (mutation.type === 'attributes') {
          // Cas 2 : le badge existe déjà dans le DOM et le thème se contente
          // de le rendre visible en changeant style="display:none" -> "inline-flex"
          // (ou une classe). On le supprime dès qu'on détecte ce changement.
          const target = mutation.target;
          if (target.nodeType === 1 && target.hasAttribute('data-stock-badge')) {
            target.remove();
          }
        }
      }
    });

    // document.documentElement existe dès le début du parsing HTML,
    // contrairement à document.body qui peut être null si le script
    // s'exécute trop tôt (placé dans <head> sans defer par ex).
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



(function () {
  'use strict';

  // Pays utilisant la pointure US comme référence d'affichage
  const US_SIZING_COUNTRIES = ['US', 'CA', 'MX', 'PH', 'AU', 'NZ'];
  const GRID_CLASS = 'js-shoe-size-grid';
  const PROCESSED_ATTR = 'data-shoe-size-processed';

  function getPreferredSizing() {
    const country = window.__shopifyCountry;
    return US_SIZING_COUNTRIES.includes(country) ? 'US' : 'EU';
  }

  // Détecte le fieldset "Shoe size" via le name des inputs (fiable même si
  // le libellé visible est traduit par Shopify Markets/Translate & Adapt)
  // avec repli sur le texte du <legend> au cas où.
  function isShoeSizeFieldset(fieldset) {
    const hasMatchingInputName = !!fieldset.querySelector('input[name^="Shoe size" i]');
    if (hasMatchingInputName) return true;

    const legend = fieldset.querySelector('legend');
    return !!legend && /shoe size|taille/i.test(legend.textContent);
  }

  function formatSizeLabel(label, input, sizing) {
    const value = input.value || ''; // ex : "36 EU (4.5 US)"
    let size = null;

    if (sizing === 'US') {
      const match = value.match(/\(([\d.]+)\s*US\)/i);
      if (match) size = match[1];
    } else {
      const match = value.match(/^([\d.]+)\s*EU/i);
      if (match) size = match[1];
    }
    if (size === null) return;

    // On ne touche qu'au noeud texte visible pour préserver les spans
    // "visually-hidden" (accessibilité / statut "sold out").
    for (const node of label.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().length) {
        node.textContent = size;
        return;
      }
    }
    label.insertBefore(document.createTextNode(size), label.firstChild);
  }

  function applyGridLayout(fieldset) {
    // Le conteneur direct des options (div.space-around) est l'enfant
    // du fieldset situé juste après le <legend>.
    const wrapper = fieldset.querySelector(':scope > div') || fieldset;
    wrapper.classList.add(GRID_CLASS);

    // Nombre de colonnes nécessaire pour toujours tenir sur 2 lignes max,
    // quel que soit le nombre total de tailles proposées par ce produit.
    const optionCount = fieldset.querySelectorAll('input[type="radio"]').length;
    const columnsForTwoRows = Math.max(1, Math.ceil(optionCount / 2));
    wrapper.style.setProperty('--shoe-size-mobile-columns', columnsForTwoRows);
  }

  function processFieldset(fieldset) {
    if (fieldset.getAttribute(PROCESSED_ATTR) === 'true') return;

    const sizing = getPreferredSizing();
    const inputs = fieldset.querySelectorAll('input[type="radio"]');

    inputs.forEach((input) => {
      const label = fieldset.querySelector(`label[for="${input.id}"]`);
      if (label) formatSizeLabel(label, input, sizing);
    });

    applyGridLayout(fieldset);
    fieldset.setAttribute(PROCESSED_ATTR, 'true');
  }

  function scan(root) {
    const scope = root || document;
    let candidates;

    if (scope.matches && scope.matches('fieldset')) {
      candidates = [scope];
    } else if (scope.querySelectorAll) {
      candidates = Array.from(scope.querySelectorAll('variant-selects fieldset'));
    } else {
      candidates = [];
    }

    candidates.forEach((fieldset) => {
      if (isShoeSizeFieldset(fieldset)) processFieldset(fieldset);
    });
  }

  // Passage initial, au cas où le markup est déjà présent au chargement
  scan(document);

  // Shopify remplace entièrement <variant-selects> (ou son fieldset) à
  // chaque changement de variante (couleur, etc.) : on garde l'observer
  // actif en permanence, contrairement au script BCPO qui se déconnectait
  // après la première détection.
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        scan(node);
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();


(function () {
  const NOTE_CLASS = 'aov-import-tax-note';

  const TRANSLATIONS = {
    en: "Import taxes may apply depending on your country's regulations. You'll receive a payment link from the carrier upon delivery.",
    fr: "Des taxes d'importation peuvent s'appliquer selon la réglementation de votre pays. Vous recevrez un lien de paiement du transporteur à la livraison.",
    es: "Pueden aplicarse impuestos de importación según la normativa de tu país. Recibirás un enlace de pago del transportista en el momento de la entrega."
  };

  function getLang() {
    // Shopify expose généralement la langue via window.Shopify.locale
    let lang = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en';
    lang = lang.toLowerCase().split('-')[0]; // "fr-FR" -> "fr"
    return TRANSLATIONS[lang] ? lang : 'en';
  }

  function insertNote(footer) {
    if (footer.querySelector('.' + NOTE_CLASS)) return;

    const note = document.createElement('small');
    note.className = NOTE_CLASS;
    note.textContent = TRANSLATIONS[getLang()];
    // Pour réafficher le message de taxes d'importation, remplacer 'none' par 'block'
    note.style.display = 'none';
    note.style.color = 'rgb(255, 255, 255)';
    note.style.fontFamily = 'Poppins';
    note.style.fontSize = '11px';
    note.style.opacity = '0.8';
    note.style.padding = '6px 0';

    footer.insertBefore(note, footer.firstChild);
  }

  function scanForFooter(root) {
    const footer = root.querySelector
      ? root.querySelector('.AOV-CDMinimal__Footer')
      : null;
    if (footer) insertNote(footer);
  }

  // Vérification initiale si déjà présent
  scanForFooter(document);

  // Observer pour les ajouts dynamiques (drawer de panier, etc.)
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;

        if (node.classList && node.classList.contains('AOV-CDMinimal__Footer')) {
          insertNote(node);
        } else {
          scanForFooter(node);
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();


// LIVRAISON OFFERTE - Badge + Baniere
(function () {
  // === Liste des pays de l'UE ===
  var EU_COUNTRIES = [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
    'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
    'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'
  ];

  // === Pays d'Amérique latine bénéficiant de la livraison gratuite ===
  var LATAM_FREE_SHIPPING_COUNTRIES = ['MX', 'BR', 'AR', 'CL', 'CO'];

  // === 1. Détection du pays ===
  function getCountry() {
    if (window.Shopify && Shopify.country) {
      return Shopify.country;
    }

    var select = document.querySelector('select[name="country_code"], input[name="country_code"]');
    if (select && select.value) {
      return select.value;
    }

    var match = document.cookie.match(/(?:^|;\s*)country=([^;]+)/);
    if (match) {
      return decodeURIComponent(match[1]);
    }

    return null;
  }

  // === 2. Textes originaux (tels qu'ils sont dans le HTML) ===
  var ORIGINAL = {
    shipping: 'Free Shipping 🎁',
    payment: 'Buy now, pay later 💸'
  };

  // === 3. Traductions par pays ===
  var TRANSLATIONS = {
    US: {
      shipping: 'Free Shipping 🎁',
      payment: 'Buy now, pay later 💸'
    },
    FR: {
      shipping: 'Livraison offerte 🎁',
      payment: 'Payez en 4 fois 💸'
    },
    DEFAULT: {
      shipping: 'Worldwide Shipping 🌍',
      payment: '4x Payments 💸'
    }
  };

  // === 4. Résolution des textes selon le pays (EU inclus) ===
  function getTexts(country) {
    if (country === 'US' || country === 'CA') return TRANSLATIONS.US;
    if (country === 'FR') return TRANSLATIONS.FR;
    if (EU_COUNTRIES.indexOf(country) !== -1) {
      // Pays UE (hors FR) : livraison gratuite comme FR, paiement en 4x garde le texte par défaut
      return {
        shipping: TRANSLATIONS.FR.shipping,
        payment: TRANSLATIONS.DEFAULT.payment
      };
    }
    if (LATAM_FREE_SHIPPING_COUNTRIES.indexOf(country) !== -1) {
      // Mexique, Brésil, Argentine, Chili, Colombie : livraison gratuite, paiement par défaut
      return {
        shipping: TRANSLATIONS.US.shipping,
        payment: TRANSLATIONS.DEFAULT.payment
      };
    }
    return TRANSLATIONS.DEFAULT;
  }

  // === 5. Application des traductions ===
  function applyReplacements(root) {
    var country = getCountry();
    var texts = getTexts(country);

    var spans = root.querySelectorAll('.announcement-bar__message span');
    spans.forEach(function (span) {
      var current = span.textContent.trim();

      var isShipping = isKnownVariant(current, 'shipping');
      var isPayment = isKnownVariant(current, 'payment');

      if (isShipping && current !== texts.shipping) {
        span.textContent = texts.shipping;
      } else if (isPayment && current !== texts.payment) {
        span.textContent = texts.payment;
      }
    });
  }

  function isKnownVariant(text, key) {
    if (text === ORIGINAL[key]) return true;
    for (var country in TRANSLATIONS) {
      if (TRANSLATIONS[country][key] === text) return true;
    }
    return false;
  }

  // === 6. Init + MutationObserver ===
  function init() {
    var track = document.querySelector('.dynamic-announcement-track');
    if (!track) return;

    applyReplacements(track);

    var observer = new MutationObserver(function () {
      observer.disconnect();
      applyReplacements(track);
      observer.observe(track, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });

    observer.observe(track, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  // === IDs des conteneurs à cibler ===
  var TARGET_IDS = [
    'ProductBadges-badges_PnVNH7',
    'ProductBadges-badges_JeVnpC',
    'ProductBadges-badges_9P3mKG'
  ];

  // === Liste des pays de l'UE (hors France, traitée séparément) ===
  var EU_COUNTRIES = [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI',
    'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
    'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'
  ];

  // === Pays d'Amérique latine bénéficiant de la livraison gratuite ===
  var LATAM_FREE_SHIPPING_COUNTRIES = ['MX', 'BR', 'AR', 'CL', 'CO'];

  // === 1. Détection du pays ===
  function getCountry() {
    if (window.Shopify && Shopify.country) {
      return Shopify.country;
    }

    var select = document.querySelector('select[name="country_code"], input[name="country_code"]');
    if (select && select.value) {
      return select.value;
    }

    var match = document.cookie.match(/(?:^|;\s*)country=([^;]+)/);
    if (match) {
      return decodeURIComponent(match[1]);
    }

    return null;
  }

  // === 2. Détection de la langue ===
  function getLang() {
    var lang = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en';
    lang = lang.toLowerCase().split('-')[0];
    return ['fr', 'en', 'es'].indexOf(lang) !== -1 ? lang : 'en';
  }

  // === 3. Traductions - Badge 1 (livraison gratuite) ===
  var TRANSLATIONS_BADGE1 = {
    en: {
      free: 'FREE<br>Shipping',
      worldwide: 'Worldwide<br>Shipping'
    },
    fr: {
      free: 'Livraison<br>OFFERTE',
      worldwide: 'Livraison<br>Mondiale'
    },
    es: {
      free: 'Envío<br>GRATIS',
      worldwide: 'Envío<br>Mundial'
    }
  };

  // === 4. Traductions - Badge 2 (délai de livraison) ===
  var TRANSLATIONS_BADGE2 = {
    en: {
      france: 'Delivery<br>in 2 days',
      europe: 'Delivery<br>in 3-5 days',
      intl: 'Delivery<br>in 5-7 days'
    },
    fr: {
      france: 'Livraison<br>en 2 jours',
      europe: 'Livraison<br>en 3 à 5 jours',
      intl: 'Livraison<br>en 5 à 7 jours'
    },
    es: {
      france: 'Envío en<br>2 días',
      europe: 'Envío en<br>3 a 5 días',
      intl: 'Envío en<br>5 a 7 días'
    }
  };

  // === 4bis. Traductions - Badge 3 (garantie) ===
  var TRANSLATIONS_BADGE3 = {
    en: {
      eu: '2 Years<br>Warranty',
      intl: '1 Year<br>Warranty'
    },
    fr: {
      eu: '2 ans de<br>garantie',
      intl: '1 an de<br>garantie'
    },
    es: {
      eu: '2 años de<br>garantía',
      intl: '1 año de<br>garantía'
    }
  };

  // === 5. Images ===
  var IMG_FREE = '//atmosgear.com/cdn/shop/files/gift-outline_bcc55610-82d0-49fb-8c9c-94388f9e625f.svg?v=1786658464&width=100';
  var IMG_WORLD = '//atmosgear.com/cdn/shop/files/GlobeAlt_1_ba074af5-bfa9-4adf-bb0f-5c02dd0a5a9a.svg?v=1750438192&width=100';
  var IMG_TRUCK = '//atmosgear.com/cdn/shop/files/Truck.svg?v=1750438595&width=100';
  var IMG_WARRANTY = '//atmosgear.com/cdn/shop/files/warranty_64.png?v=1750438710&width=100';

  // === Pays européens hors UE (garantie 2 ans) ===
  var EUROPE_NON_EU_COUNTRIES = [
    'GB', 'CH', 'NO', 'IS', 'LI',
    'AD', 'MC', 'SM', 'VA',
    'AL', 'BA', 'ME', 'MK', 'RS', 'XK',
    'MD', 'UA',
    'GI', 'JE', 'GG', 'IM'
  ];

  // === Helper : pays de l'UE (France incluse) ===
  function isEU(country) {
    return country === 'FR' || EU_COUNTRIES.indexOf(country) !== -1;
  }

  // === Helper : pays européens (UE + hors UE) ===
  function isEurope(country) {
    return isEU(country) || EUROPE_NON_EU_COUNTRIES.indexOf(country) !== -1;
  }

  // === 6. Config Badge 1 (livraison gratuite) selon pays + langue ===
  function getBadge1Config() {
    var country = getCountry();
    var lang = getLang();
    var t = TRANSLATIONS_BADGE1[lang];

    if (
      country === 'US' ||
      country === 'CA' ||
      isEU(country) ||
      LATAM_FREE_SHIPPING_COUNTRIES.indexOf(country) !== -1
    ) {
      return { src: IMG_FREE, text: t.free };
    }

    return { src: IMG_WORLD, text: t.worldwide };
  }

  // === 7. Config Badge 2 (délai de livraison) selon pays + langue ===
  function getBadge2Config() {
    var country = getCountry();
    var lang = getLang();
    var t = TRANSLATIONS_BADGE2[lang];

    if (country === 'FR') {
      return { src: IMG_TRUCK, text: t.france };
    }

    if (EU_COUNTRIES.indexOf(country) !== -1) {
      return { src: IMG_TRUCK, text: t.europe };
    }

    // US + Amérique latine + reste du monde
    return { src: IMG_TRUCK, text: t.intl };
  }

  // === 7bis. Config Badge 3 (garantie) selon pays + langue ===
  // Pays européens (UE + hors UE) : 2 ans | Reste du monde : 1 an
  function getBadge3Config() {
    var country = getCountry();
    var lang = getLang();
    var t = TRANSLATIONS_BADGE3[lang];

    if (isEurope(country)) {
      return { src: IMG_WARRANTY, text: t.eu };
    }

    return { src: IMG_WARRANTY, text: t.intl };
  }

  // === 8. Application générique sur un badge donné ===
  function applyBadgeUpdate(badgeEl, config) {
    if (!badgeEl) return;

    var img = badgeEl.querySelector('img');
    var textEl = badgeEl.querySelector('.badge-text');

    if (img && img.getAttribute('src') !== config.src) {
      img.setAttribute('src', config.src);
    }

    if (textEl && textEl.innerHTML.trim() !== config.text) {
      textEl.innerHTML = config.text;
    }
  }

  // === 9. Traite les conteneurs ciblés : badges 1, 2 et 3 ===
  function applyAll() {
    var config1 = getBadge1Config();
    var config2 = getBadge2Config();
    var config3 = getBadge3Config();

    TARGET_IDS.forEach(function (id) {
      var container = document.getElementById(id);
      if (!container) return;

      var badges = container.querySelectorAll('.badge-item');
      applyBadgeUpdate(badges[0], config1); // 1er badge : livraison gratuite
      applyBadgeUpdate(badges[1], config2); // 2e badge : délai de livraison
      applyBadgeUpdate(badges[2], config3); // 3e badge : garantie
    });
  }

  // === 10. Init + MutationObserver global ===
  function init() {
    applyAll();

    var observer = new MutationObserver(function () {
      observer.disconnect();
      applyAll();
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['src']
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['src']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  function styleAsText(dropdown) {
    if (dropdown.dataset.textified === 'true') return;

    const header = dropdown.querySelector('.Vtl-Dropdown__Header');
    if (!header) return;

    dropdown.style.pointerEvents = 'none';
    header.removeAttribute('tabindex');
    header.removeAttribute('role');
    header.removeAttribute('aria-haspopup');
    header.removeAttribute('aria-expanded');
    header.setAttribute('aria-hidden', 'true');

    header.style.cursor = 'default';
    header.style.background = 'transparent';
    header.style.border = 'none';
    header.style.boxShadow = 'none';
    header.style.padding = '0';
    header.style.minHeight = 'auto';

    const arrow = header.querySelector('.Vtl-Dropdown__Header-ArrowContainer');
    if (arrow) arrow.style.display = 'none';

    const selectedText = header.querySelector('.Vtl-Dropdown__Header-Selected');
    if (selectedText) {
      selectedText.style.fontWeight = '500';
      selectedText.style.color = '#ffffff';
    }

    dropdown.dataset.textified = 'true';
  }

  function applyStyling() {
    // Pour chaque tier, on cible uniquement le 1er item de variante (#1)
    document.querySelectorAll('.Vtl-VolumeDiscountRadio__TierItem').forEach((tier) => {
      const firstVariantItem = tier.querySelector('.Vtl-VolumeDiscountRadio__VariantsItem:first-child .Vtl-Dropdown');
      if (firstVariantItem) {
        styleAsText(firstVariantItem);
      }
    });
  }

  applyStyling();

  const observer = new MutationObserver(() => {
    applyStyling();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

(function () {
  if (window.innerWidth > 768) return;

  const originalButton = document.querySelector('.product-form__submit[type="submit"]');
  if (!originalButton) return;

  // Clone visuel du bouton, sans jamais toucher au bouton original
  const stickyButton = originalButton.cloneNode(true);
  stickyButton.removeAttribute('id'); // évite un doublon d'ID dans le DOM

  const wrapper = document.createElement('div');
  wrapper.style.position = 'fixed';
  wrapper.style.bottom = '0';
  wrapper.style.left = '0';
  wrapper.style.right = '0';
  wrapper.style.width = '100%';
  wrapper.style.zIndex = '15';
  wrapper.style.padding = '10px';
  wrapper.style.background = '#100f0d';
  wrapper.style.transition = 'transform 0.35s ease, opacity 0.35s ease';
  wrapper.style.transform = 'translateY(100%)';
  wrapper.style.opacity = '0';
  wrapper.appendChild(stickyButton);
  document.body.appendChild(wrapper);

  // Le clic sur le clone déclenche le vrai bouton (submit du formulaire d'origine)
  stickyButton.addEventListener('click', function (e) {
    e.preventDefault();
    originalButton.click();
  });

  const THRESHOLD = 1000;
  let isSticky = false;

  function onScroll() {
    const scrollY = window.scrollY;

    if (scrollY > THRESHOLD && !isSticky) {
      isSticky = true;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          wrapper.style.transform = 'translateY(0)';
          wrapper.style.opacity = '1';
        });
      });
    }

    if (scrollY <= THRESHOLD && isSticky) {
      isSticky = false;
      wrapper.style.transform = 'translateY(100%)';
      wrapper.style.opacity = '0';
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
})();





/**
 * GUIDE DES TAILLES — ALIGNEMENT SUR LA LIGNE "TAILLE DE LA CHAUSSURE"
 * ---------------------------------------------------------------------
 * Déplace le bouton "Guide des Tailles" (modal-opener) pour qu'il
 * s'affiche sur la même ligne que le label "Taille de la Chaussure",
 * aligné à droite.
 */
(function () {
  'use strict';

  // ID de la section ciblée uniquement (pas d'effet sur les autres produits)
  var SECTION_ID = 'ProductInfo-template--32242383552854__main';

  function moveSizeGuideNextToLabel() {
    var section = document.getElementById(SECTION_ID);
    if (!section) return;

    var legend = section.querySelector('fieldset[data-shoe-size-processed="true"] > legend.form__label');
    var sizeGuideOpener = section.querySelector('.product-popup-modal__opener');

    if (!legend || !sizeGuideOpener) return;
    if (legend.contains(sizeGuideOpener)) return; // déjà déplacé, rien à faire

    // Styles appliqués directement en JS (pas de CSS externe nécessaire)
    legend.style.display = 'flex';
    legend.style.alignItems = 'center';
    legend.style.flexWrap = 'wrap';
    legend.style.justifyContent = 'space-between';
    legend.style.gap = '6px 12px';
    legend.style.width = '100%';

    sizeGuideOpener.style.marginLeft = 'auto';

    var sizeGuideButton = sizeGuideOpener.querySelector('.product-popup-modal__button');
    if (sizeGuideButton) {
      sizeGuideButton.style.fontSize = '13px';
      sizeGuideButton.style.whiteSpace = 'nowrap';
    }

    legend.appendChild(sizeGuideOpener);
  }

  function init() {
    moveSizeGuideNextToLabel();

    // Filet de sécurité : si le thème re-génère le fieldset (changement de
    // variante géré côté serveur sur certains thèmes), on refait le déplacement.
    var section = document.getElementById(SECTION_ID);
    if (!section) return;

    var observer = new MutationObserver(function () {
      moveSizeGuideNextToLabel();
    });

    observer.observe(section, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();




/**
 * MASQUER LES MINIATURES QUAND IL N'Y A QU'UNE SEULE IMAGE
 * ---------------------------------------------------------------------
 * S'applique à toutes les pages produit (cible <media-gallery>, présent
 * sur chaque template produit, pas besoin de cibler un ID de section).
 *
 * Fonctionnement :
 * 1. Dans chaque <media-gallery>, on repère le bloc de miniatures
 *    (.thumbnail-slider) et on compte les miniatures RÉELLEMENT
 *    visibles (certaines sont masquées en display:none selon la
 *    couleur/variante sélectionnée).
 * 2. S'il n'y a qu'une miniature visible (ou aucune), on masque tout
 *    le bloc de miniatures.
 * 3. Un MutationObserver sur document.body (et non sur les éléments
 *    individuels) recalcule à chaque changement, y compris si le
 *    thème régénère entièrement le bloc galerie plus tard.
 */
(function () {
  function countVisibleThumbnails(thumbSlider) {
    var items = thumbSlider.querySelectorAll('.thumbnail-list__item');
    var visibleCount = 0;

    items.forEach(function (item) {
      if (window.getComputedStyle(item).display !== 'none') {
        visibleCount++;
      }
    });

    return visibleCount;
  }

  function updateThumbnailsVisibility() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      var thumbSlider = gallery.querySelector('.thumbnail-slider');
      if (!thumbSlider) return;

      var visibleCount = countVisibleThumbnails(thumbSlider);

      if (visibleCount <= 1) {
        thumbSlider.style.display = 'none';
      } else {
        thumbSlider.style.display = '';
      }
    });
  }

  // Empêche de relancer le calcul en boucle : on ignore les mutations
  // provoquées par notre propre updateThumbnailsVisibility().
  var isUpdating = false;

  function safeUpdate() {
    if (isUpdating) return;
    isUpdating = true;
    updateThumbnailsVisibility();
    // Laisse le temps au navigateur d'appliquer les styles avant de
    // réautoriser une nouvelle mise à jour déclenchée par une mutation.
    requestAnimationFrame(function () {
      isUpdating = false;
    });
  }

  function init() {
    safeUpdate();

    var observer = new MutationObserver(function () {
      safeUpdate();
    });

    // On observe tout document.body plutôt que chaque <media-gallery>
    // individuellement : ça continue de fonctionner même si le thème
    // remplace/régénère entièrement le bloc galerie plus tard.
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();